module.exports = __webpack_public_path__ + "img/47.91d55326.png";